import { FC } from "react";
import { View, ViewProps } from "react-native";
import * as Slot from "@rn-primitives/slot";
import { type VariantProps } from "class-variance-authority";

import { TextClassContext } from "@/context/TextClassContext";
import { ChildrenOrI18nType } from "@/i18n";
import { cn } from "@/utils/tailwind";

import { VnText } from "../VnText/VnText";
import { badgeTextVariants, badgeVariants } from "./variants";

type VnBadgePropsType = ViewProps &
  ChildrenOrI18nType & {
    asChild?: boolean;
  } & VariantProps<typeof badgeVariants>;

export const VnBadge: FC<VnBadgePropsType> = ({
  className,
  variant,
  asChild,
  children,
  i18nKey,
  i18nOptions,
  ...props
}) => {
  const Component = asChild ? Slot.View : View;
  return (
    <TextClassContext.Provider value={badgeTextVariants({ variant })}>
      <Component
        className={cn(badgeVariants({ variant }), className)}
        {...props}>
        {children ?? <VnText i18nKey={i18nKey} i18nOptions={i18nOptions} />}
      </Component>
    </TextClassContext.Provider>
  );
};
